import React from 'react';
import { CustomizedTypography } from '@components/Customized';
import { Box, Divider } from '@material-ui/core';
import useStyles from './useStyles';

interface Props {
  unread?: boolean;
  createdAt?: string;
}

const ChatDateDividerPresenter: React.FC<Props> = ({ unread, createdAt }) => {
  const classes = useStyles();

  if (!createdAt) return null;

  const createdDate = new Date(createdAt);
  const createdYear = createdDate.getFullYear();
  const createdMonth = createdDate.getMonth();
  const createdDay = createdDate.getDate();

  return (
    <Box className={classes['Chat-Message-Date-Divider']}>
      <div className="divider-wrapper">
        <Divider className="divider" />
      </div>
      {unread ? (
        <CustomizedTypography
          className="date"
          variant="caption"
          color="textSecondary"
          align="center"
        >
          여기까지 읽음
        </CustomizedTypography>
      ) : (
        <CustomizedTypography
          className="date"
          variant="caption"
          color="textSecondary"
          align="center"
        >
          {createdYear + '년 ' + (createdMonth + 1) + '월 ' + createdDay + '일'}
        </CustomizedTypography>
      )}
      <div className="divider-wrapper">
        <Divider className="divider" />
      </div>
    </Box>
  );
};

export default ChatDateDividerPresenter;
